<template>
    <div class="">
        <div class="">
            <div v-for="(plan, planIdx) in form" :key="planIdx">
                <div v-if="plan.type === 'unit'">
                    <b-form-group>
                        <b-form-checkbox
                            :id="`plan-${planIdx}`"
                            v-model="plan.checked"
                            :unchecked-value="false"
                        >
                            {{ plan.name }}
                        </b-form-checkbox>
                    </b-form-group>
                </div>
                <div v-if="plan.type === 'volume'">
                    <b-form-group :label="plan.name">
                        <b-form-input
                            :id="`plan-${planIdx}`"
                            v-model="plan.quantity"
                            type="number"
                            :placeholder="plan.name"
                            :min="plan.quantity_min"
                            required
                        />

                        <div class="p-1 small">
                            <div>
                                Quantidade Mínima: <b>{{ plan.quantity_min }}</b> unidades.
                            </div>
                            <div v-for="(option, optionIdx) in plan.options" :key="optionIdx">
                                De <b>{{ option.start_quantity }}</b> até <b>{{ option.end_quantity }}</b> custa <b>{{ formatPrice(option.price) }}</b> por unidade.
                            </div>
                            <div>
                                Acima dessas quantidades, custa <b>{{ formatPrice(plan.overage_price) }}</b> por unidade.
                            </div>
                        </div>
                    </b-form-group>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <resume-subscription :resume="resume" />
        </div>
    </div>
</template>
<script>
import plans from "../subscription/mixins/plans";
import price from "../subscription/mixins/price";
import ResumeSubscription from "../components/ResumeSubscription.vue";

export default {
    components: {
        ResumeSubscription
    },
    mixins: [plans, price],
    data() {
        return {
            form: []
        }
    },
    computed: {
        resume() {
            return this.calculeResume(this.form)
        }
    },
    watch: {
        form: {
            handler: function (value) {
                this.$emit('update', value)
            },
            deep: true
        }
    },
    async created() {
        this.form = await this.loadPlans()
    }
}
</script>

<style scoped>

</style>
